import React, { useEffect, useState } from 'react';
import { useAuthContext } from '../../../contexts/AuthContext';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { firestore } from '../../../config/firebase';

export default function Index() {
  const [enrolledCourses, setEnrolledCourses] = useState([]);
  const [quizResult, setQuizResult] = useState([]);
  const [questionsResult, setQuestionsResult] = useState([]);
  const { user } = useAuthContext();

  const getQuizResult = async () => {
    const q = query(collection(firestore, 'quizRecord'), where('attemptedUserId', '==', user.uid), where('status', '==', "active"));
    const querySnapshot = await getDocs(q);
    const array = [];
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      array.push(data);
    });
    setQuizResult(array);
  };
  const getQuestionResult = async () => {
    const q = query(collection(firestore, 'questionsResult'), where('attemptedUserId', '==', user.uid), where('status', '==', "active"));
    const querySnapshot = await getDocs(q);
    const array = [];
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      array.push(data);
    });
    setQuestionsResult(array);
  };
  const getEnrolledCourses = async () => {
    const q = query(collection(firestore, 'registeredCourses'), where('enrolledBy', '==', user.uid));
    const querySnapshot = await getDocs(q);
    const array = [];
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      array.push(data);
    });
    setEnrolledCourses(array);
  };

  useEffect(() => {
    getEnrolledCourses();
    getQuizResult();
    getQuestionResult();
  }, []);

  return (
    <>
      <div className='mt-24'>
        <h1 className='text-[48px] text-center underline text-[#fffa8a] italic'>Welcome {user.fullName}</h1>
        {enrolledCourses.length > 0 && (
          <div>
            <h3 className='text-[37px] text-center text-[#fffa8a] italic mt-10'>Courses Enrolled</h3>
            <div className="container max-w-[90%] text-[#fffa8a] px-4 mx-auto sm:px-8" style={{ background: "transparent" }}>
              <div className="py-8">
                <div className="px-4 py-4 -mx-4 overflow-x-auto sm:-mx-8 sm:px-8">
                  <div className="inline-block min-w-full overflow-hidden rounded-lg shadow">
                    <table className="min-w-full leading-normal">
                      <thead>
                        <tr>
                          <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                            Title
                          </th>
                          <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                            Price
                          </th>
                          <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                            Duration
                          </th>
                          <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                            Enrolled Date
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {enrolledCourses.map((rowData, index) => (
                          <tr key={index}>
                            <td className="px-5 py-5 text-sm  border-b text-left border-[#fffa8a] text-[#fffa8a]">
                              <div className="flex items-center">
                                <div>
                                  <p className=" whitespace-no-wrap">{rowData.courseName}</p>
                                </div>
                              </div>
                            </td>
                            <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                              <p className=" whitespace-no-wrap">{rowData.coursePrice}</p>
                            </td>
                            <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                              <p className=" whitespace-no-wrap">{rowData.courseDuration}</p>
                            </td>
                            <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                              {rowData.enrolledAt}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {quizResult.length > 0 && <div>
          <h1 className='text-[37px] text-center text-[#fffa8a] italic mt-10'>All quizes Results</h1>
          <div className="container max-w-[90%] text-[#fffa8a] px-4 mx-auto sm:px-8" style={{ background: "transparent" }}>
            <div className="py-8">
              <div className="px-4 py-4 -mx-4 overflow-x-auto sm:-mx-8 sm:px-8">
                <div className="inline-block min-w-full overflow-hidden rounded-lg shadow">
                  <table className="min-w-full leading-normal" >
                    <thead>
                      <tr>
                        <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                          Student Name
                        </th>
                        <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                          Time
                        </th>
                        <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                          Score
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      {quizResult.map((rowData, index) => (
                        <tr key={index}>

                          <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                            <p className=" whitespace-no-wrap">{rowData.attemptedBy}</p>
                          </td>
                          <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                            <p className=" whitespace-no-wrap">{rowData.attemptedTime}</p>
                          </td>
                          <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                            {rowData.correctQuestions}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>}
      </div>
      {questionsResult.length > 0 && (
        <div>
          <h3 className='text-[37px] text-center text-[#fffa8a] italic mt-10'>Courses Enrolled</h3>
          <div className="container max-w-[90%] text-[#fffa8a] px-4 mx-auto sm:px-8" style={{ background: "transparent" }}>
            <div className="py-8">
              <div className="px-4 py-4 -mx-4 overflow-x-auto sm:-mx-8 sm:px-8">
                <div className="inline-block min-w-full overflow-hidden rounded-lg shadow">
                  <table className="min-w-full leading-normal">
                    <thead>
                      
                      <tr>
                        <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                          Name
                        </th>
                        <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                          Test Date
                        </th>
                        <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                         Marks
                        </th>
                      </tr>
                  
                    </thead>
                    <tbody>
                      {questionsResult.map((rowData, index) => (
                        <tr key={index}>
                          <td className="px-5 py-5 text-sm  border-b text-left border-[#fffa8a] text-[#fffa8a]">
                            <div className="flex items-center">
                              <div>
                                <p className=" whitespace-no-wrap">{rowData.attemptedBy}</p>
                              </div>
                            </div>
                          </td>
                          <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                            <p className=" whitespace-no-wrap">{rowData.attemptedTime}</p>
                          </td>
                          <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                            <p className=" whitespace-no-wrap">{!rowData.result?"Not Decleared Yet":rowData.result}</p>
                          </td>
                         
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
